import { TipsButton } from '@/pages/translation/components/Header/TipsButton';
import styled from '@emotion/styled';
import { CreateButton } from './CreateButton';
import { Search } from './Search';

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const Buttons = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-left: auto;
`;

export const Header = () => {
    return (
        <Container>
            <Search />

            <Buttons>
                <TipsButton />
                <CreateButton />
            </Buttons>
        </Container>
    );
};
